var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", [
        _c("p", {
          staticClass: "icon-jujue closeBtn",
          on: { click: _vm.routerBack },
        }),
      ]),
      _c(
        "div",
        { staticClass: "content_box" },
        [
          _c(
            "el-row",
            { staticStyle: { margin: "5px 0" } },
            [
              _vm.ms_roles.indexOf("QSPI_RMC_CHICK_SPONS_SUPP") !== -1 ||
              _vm.ms_roles.indexOf("QSPI_RMC_PORK_SPONS_SUPP") !== -1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RMC_PROT_FARM_SUBMIT,
                          expression: "RMC_PROT_FARM_SUBMIT",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onSubmit },
                    },
                    [_vm._v("提交")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-form",
            {
              ref: "detailForm",
              attrs: {
                model: _vm.detailForm,
                rules: _vm.rules,
                "label-width": "120px",
              },
            },
            [
              _c("div", { staticClass: "within_box" }, [
                _c("div", { staticClass: "title_box" }, [
                  _c("p", { staticClass: "line" }),
                  _c("p", { staticClass: "title" }, [_vm._v("饲料厂清单")]),
                ]),
                _c(
                  "div",
                  { staticClass: "form_box" },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "Category3",
                                  prop: "category3Name",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.category3Name,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "category3Name",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.category3Name",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "Sponsor",
                                  prop: "sponsorName",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.sponsorName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "sponsorName",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.sponsorName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "ASL Group",
                                  prop: "aslGroupName",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.aslGroupName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "aslGroupName",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.aslGroupName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "饲料厂",
                                  prop: "feedFactoryName",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.feedFactoryName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "feedFactoryName",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.feedFactoryName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "审核类型", prop: "party" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      clearable: "",
                                      placeholder: "请选择",
                                    },
                                    on: { change: _vm.partyChange },
                                    model: {
                                      value: _vm.detailForm.party,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.detailForm, "party", $$v)
                                      },
                                      expression: "detailForm.party",
                                    },
                                  },
                                  _vm._l(
                                    _vm.partyOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.label,
                                          value: item.value,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _vm.isShow
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "1方验证审核结果",
                                      prop: "partyAuditResult1",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.detailForm.partyAuditResult1,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.detailForm,
                                            "partyAuditResult1",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "detailForm.partyAuditResult1",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _vm.isShow
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "1方验证审核时间",
                                      prop: "partyAuditDate1",
                                    },
                                  },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        type: "date",
                                        "value-format": "yyyy-MM-dd",
                                        placeholder: "请选择",
                                      },
                                      model: {
                                        value: _vm.detailForm.partyAuditDate1,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.detailForm,
                                            "partyAuditDate1",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "detailForm.partyAuditDate1",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            !_vm.isShow
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "2方验证审核结果",
                                      prop: "partyAuditResult2",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.detailForm.partyAuditResult2,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.detailForm,
                                            "partyAuditResult2",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "detailForm.partyAuditResult2",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            !_vm.isShow
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "2方验证审核时间",
                                      prop: "partyAuditDate2",
                                    },
                                  },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        type: "date",
                                        "value-format": "yyyy-MM-dd",
                                        placeholder: "请选择",
                                      },
                                      model: {
                                        value: _vm.detailForm.partyAuditDate2,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.detailForm,
                                            "partyAuditDate2",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "detailForm.partyAuditDate2",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "within_box" }, [
                _c("div", { staticClass: "title_box" }, [
                  _c("p", { staticClass: "line" }),
                  _c("p", { staticClass: "title" }, [_vm._v("验证审核报告")]),
                ]),
                _c(
                  "div",
                  { staticClass: "form_box" },
                  [
                    _c(
                      "el-row",
                      { staticStyle: { "margin-bottom": "5px" } },
                      [
                        _vm.ms_roles.indexOf("QSPI_RMC_CHICK_SPONS_SUPP") !==
                          -1 ||
                        _vm.ms_roles.indexOf("QSPI_RMC_PORK_SPONS_SUPP") !== -1
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "acl",
                                    rawName: "v-acl",
                                    value: _vm.RMC_PROT_FARM_UPLOAD,
                                    expression: "RMC_PROT_FARM_UPLOAD",
                                  },
                                ],
                                attrs: { size: "small", type: "primary" },
                                on: { click: _vm.openFile },
                              },
                              [_vm._v("上传")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "el-table",
                      {
                        ref: "plxTable",
                        attrs: {
                          data: _vm.tableData,
                          "max-height": "500",
                          border: "",
                          "highlight-current-row": "",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "操作",
                            width: "80",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm.ms_userId === scope.row.createBy
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onDel(
                                                scope.row.tmDocumentId,
                                                scope.$index,
                                                _vm.tableData
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "文件类型",
                            prop: "reportType",
                            "show-overflow-tooltip": "",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "文件名称",
                            prop: "documentName",
                            "show-overflow-tooltip": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onDownload(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(scope.row.documentName))]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "文件描述",
                            prop: "docComments",
                            "show-overflow-tooltip": "",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "上传人",
                            prop: "userName",
                            "show-overflow-tooltip": "",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "上传时间",
                            prop: "createDate",
                            "show-overflow-tooltip": "",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.dialogVisible,
            width: "30%",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.dialogVisible
            ? _c("uploadFile", {
                attrs: { seq: _vm.seq, bizId: _vm.bizId, recType: _vm.recType },
                on: { close: _vm.handleClose },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }